import { flattenObject, isNil } from 'es-toolkit'

export function createFormData(body: Record<string, unknown>) {
  const formData = new FormData()

  for (const [key, value] of Object.entries(flattenObject(body))) {
    if (isNil(value)) continue

    const formKey = key.replaceAll(/\.([0-9]+)(?=\.|$)/g, '[$1]')
    if (formKey.endsWith(']')) {
      formData.append(formKey.substring(0, formKey.lastIndexOf('[')), value as string | Blob)
    } else {
      formData.append(formKey, value as string | Blob)
    }
  }

  return formData
}
